document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mini-split-calculator]').forEach((root) => {
    const i18n = JSON.parse(root.querySelector('[data-ms-i18n]')?.textContent || '{}');

    function t(template, vars = {}) {
      if (!template) return '';
      return Object.keys(vars).reduce(
        (str, key) => str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), vars[key]),
        template
      );
    }

    const el = (name) => root.querySelector(`[data-field="${name}"]`);

    function switchTab(tabId, btn) {
      root.querySelectorAll('.ms-calc-section').forEach((s) => s.classList.remove('active'));
      root.querySelectorAll('.ms-tab-btn').forEach((b) => b.classList.remove('active'));
      root.querySelector(`[data-ms-tab="${tabId}"]`)?.classList.add('active');
      btn.classList.add('active');
    }

    function activateTab(tabId) {
      const btn = root.querySelector(`[data-ms-tab-trigger="${tabId}"]`);
      if (btn) switchTab(tabId, btn);
    }

    root.addEventListener('mini-split-activate-tab', (e) => {
      if (e.detail?.tabId) activateTab(e.detail.tabId);
    });

    const TURBRO_ROOM_TYPE_MODIFIERS = { bedroom: 0, living_room: 10, garage: 15, basement: -10, workshop: 10, sunroom: 20, office: 5 };
    const TURBRO_CEILING_MODIFIERS = { 8: 0, 9: 10, 10: 20 };
    const TURBRO_CLIMATE_MODIFIERS = { mixed: 0, hot: 10, cold: 5, extreme_cold: 15 };
    const TURBRO_CLIMATE_LABELS = i18n.climate_labels || { mixed: 'Mixed Climate', hot: 'Hot Climate', cold: 'Cold Climate', extreme_cold: 'Extreme Cold' };
    const TURBRO_INSULATION_MODIFIERS = { excellent: -10, average: 0, poor: 15 };
    const SERIES_REFRIGERANT = { greenland: 'R454B', finnmark: 'R32', lapland: 'R32' };

    const TURBRO_PRODUCTS = JSON.parse(root.querySelector('[data-ms-products]')?.textContent || '{}');

    const REFRIG_DATA = {
      greenland: { refrigerant: 'R454B', precharge: 16.4, rate: 0.11, maxLen: { '9K': 50, '12K': 50, '18K': 65, '24K': 65 } },
      lapland: { refrigerant: 'R32', precharge: 25, rate: 0.16, maxLen: { '12K': 65.6, '18K': 98.4, '24K': 98.4 } },
      finnmark: { refrigerant: 'R32', precharge: 25, rate: 0.16, maxLen: { '9K': 65.6, '12K': 65.6, '18K': 98.4, '24K': 98.4 } }
    };

    const CAPACITY_LABELS = i18n.refrig?.capacity || { '9K': '9,000 BTU', '12K': '12,000 BTU', '18K': '18,000 BTU', '24K': '24,000 BTU' };

    function calculateBTU() {
      const length = parseFloat(el('turbro-length')?.value);
      const width = parseFloat(el('turbro-width')?.value);
      const roomType = el('turbro-room-type')?.value;
      const ceiling = el('turbro-ceiling')?.value;
      const climate = el('turbro-climate')?.value;
      const insulation = el('turbro-insulation')?.value;

      if (!length || !width) {
        alert(i18n.alerts?.room_dimensions || 'Please enter room dimensions.');
        return;
      }

      const area = length * width;
      const baseBTU = area * 25;
      const modifier =
        (TURBRO_ROOM_TYPE_MODIFIERS[roomType] || 0) +
        (TURBRO_CEILING_MODIFIERS[ceiling] || 0) +
        (TURBRO_CLIMATE_MODIFIERS[climate] || 0) +
        (TURBRO_INSULATION_MODIFIERS[insulation] || 0);
      const finalBTU = baseBTU * (1 + modifier / 100);
      const climateText = TURBRO_CLIMATE_LABELS[climate] || '';

      let recommendation = '';
      let coverage = '';
      let model = '';
      let series = '';
      let productKey = '';
      const tags = [];

      if (roomType === 'garage') tags.push(i18n.tags?.garage_ready || 'Garage Ready');
      if (climateText.includes('Cold') || climateText.includes('Extreme')) tags.push(i18n.tags?.cold_climate || 'Cold Climate');
      if (insulation === 'excellent' || climateText.includes('Extreme')) tags.push(i18n.tags?.high_seer2 || 'High SEER2');
      if (insulation === 'excellent' && roomType !== 'garage') tags.push(i18n.tags?.budget_friendly || 'Budget Friendly');

      if (finalBTU <= 9000) {
        recommendation = '9,000 BTU';
        coverage = i18n.coverage?.['9000'] || 'Best for rooms up to 400 sq.ft.';
        productKey = '9000';
        if (climateText.includes('Cold')) {
          model = 'TURBRO Greenland 9K';
          series = 'greenland';
        } else {
          model = 'TURBRO Finnmark 9K';
          series = 'finnmark';
        }
      } else if (finalBTU <= 14000) {
        recommendation = '12,000 BTU';
        coverage = i18n.coverage?.['12000'] || 'Best for rooms up to 550–750 sq.ft.';
        productKey = '12000';
        if (climateText.includes('Extreme') || roomType === 'garage') {
          model = 'TURBRO Greenland 12K';
          series = 'greenland';
        } else if (climateText.includes('Cold')) {
          model = 'TURBRO Lapland 12K';
          series = 'lapland';
        } else {
          model = 'TURBRO Finnmark 12K';
          series = 'finnmark';
        }
      } else if (finalBTU <= 20000) {
        recommendation = '18,000 BTU';
        coverage = i18n.coverage?.['18000'] || 'Best for rooms up to 850 sq.ft.';
        productKey = '18000';
        if (climateText.includes('Extreme') || roomType === 'garage' || roomType === 'workshop') {
          model = 'TURBRO Lapland 18K';
          series = 'lapland';
        } else {
          model = 'TURBRO Greenland 18K';
          series = 'greenland';
        }
      } else if (finalBTU <= 28000) {
        recommendation = '24,000 BTU';
        coverage = i18n.coverage?.['24000'] || 'Best for rooms up to 1200–1500 sq.ft.';
        productKey = '24000';
        if (climateText.includes('Extreme')) {
          model = 'TURBRO Lapland 24K';
          series = 'lapland';
        } else {
          model = 'TURBRO Greenland 24K';
          series = 'greenland';
        }
      } else {
        recommendation = '36,000 BTU';
        coverage = i18n.coverage?.['36000'] || 'Best for large open spaces up to 1800 sq.ft.';
        productKey = '36000';
        model = 'TURBRO Greenland Multi-Zone 36K';
        series = 'greenland';
      }

      const productInfo = TURBRO_PRODUCTS[productKey]?.[series] || TURBRO_PRODUCTS[productKey]?.[Object.keys(TURBRO_PRODUCTS[productKey] || {})[0]];
      const productUrl = productInfo?.url || '#';
      const baseFeatures = productInfo?.features || '';
      const refrigerant = SERIES_REFRIGERANT[series] || 'R410A';
      const finalFeatures = `${refrigerant} · ${baseFeatures}`;

      const tagsHTML = tags
        .map((tag) => {
          const tagClass =
            tag === (i18n.tags?.garage_ready || 'Garage Ready')
              ? 'garage'
              : tag === (i18n.tags?.cold_climate || 'Cold Climate')
                ? 'cold'
                : tag === (i18n.tags?.high_seer2 || 'High SEER2')
                  ? 'seer2'
                  : 'budget';
          return `<span class="ms-tag ms-tag-${tagClass}">${tag}</span>`;
        })
        .join('');

      const btuResult = i18n.btu_result || {};
      const container = el('turbro-result-container');
      if (!container) return;

      container.innerHTML = `
        <div class="ms-result-card">
          <div>${tagsHTML}</div>
          <div style="margin-top: 24px;">
            <p class="ms-result-title">${btuResult.suggested_system || 'Your Suggested System'}</p>
            <div class="ms-result-btu">${recommendation}</div>
            <p class="ms-result-coverage">${coverage}</p>
          </div>
          <div class="ms-product-card">
            <p class="ms-product-name">${model}</p>
            <p class="ms-product-features">${finalFeatures}</p>
            <a href="${productUrl}" target="_blank" rel="noopener noreferrer" class="ms-btn-view-product">${btuResult.view_product || 'View Product'}</a>
          </div>
          <div class="ms-result-details">
            <p><strong>${btuResult.room_size || 'Estimated room size:'}</strong> ${Math.round(area)} ${btuResult.sq_ft || 'sq.ft.'}</p>
            <p style="margin-top: 12px;">${btuResult.optimized_note || 'This recommendation is optimized based on room type, climate, insulation quality, and TURBRO product matching.'}</p>
          </div>
        </div>
      `;
    }

    function resetBTU() {
      if (el('turbro-length')) el('turbro-length').value = '';
      if (el('turbro-width')) el('turbro-width').value = '';
      if (el('turbro-room-type')) el('turbro-room-type').value = 'bedroom';
      if (el('turbro-ceiling')) el('turbro-ceiling').value = '8';
      if (el('turbro-climate')) el('turbro-climate').value = 'mixed';
      if (el('turbro-insulation')) el('turbro-insulation').value = 'average';
      const container = el('turbro-result-container');
      if (container) {
        container.innerHTML = `<div class="ms-result-placeholder"><p class="ms-placeholder-text">${i18n.placeholders?.btu || 'Enter your room details and click Calculate to see recommendations'}</p></div>`;
      }
    }

    function onSeriesChange() {
      const series = el('refrig-series')?.value;
      const capacitySelect = el('refrig-capacity');
      const data = REFRIG_DATA[series];
      if (!capacitySelect || !data) return;

      capacitySelect.innerHTML = '';
      Object.keys(data.maxLen).forEach((cap) => {
        const option = document.createElement('option');
        option.value = cap;
        option.text = CAPACITY_LABELS[cap];
        capacitySelect.appendChild(option);
      });

      updateRefrigParams();
    }

    function updateRefrigParams() {
      const series = el('refrig-series')?.value;
      const capacity = el('refrig-capacity')?.value;
      if (!capacity) return;

      const data = REFRIG_DATA[series];
      const maxLen = data.maxLen[capacity];

      if (el('display-type')) el('display-type').textContent = data.refrigerant;
      if (el('display-precharge')) el('display-precharge').textContent = `${data.precharge} ft`;
      if (el('display-rate')) el('display-rate').textContent = `${data.rate} oz/ft`;
      if (el('display-max')) el('display-max').textContent = `${maxLen} ft`;

      validatePipeLength();
    }

    function validatePipeLength() {
      const pipeLen = parseFloat(el('refrig-pipe-length')?.value) || 0;
      const series = el('refrig-series')?.value;
      const capacity = el('refrig-capacity')?.value;
      if (!capacity) return;

      const maxLen = REFRIG_DATA[series].maxLen[capacity];
      const warning = el('refrig-len-warning');

      if (!warning) return;

      if (pipeLen > maxLen) {
        warning.classList.add('active');
        warning.textContent = t(i18n.refrig?.warning_exceeds, { length: pipeLen, max: maxLen });
      } else {
        warning.classList.remove('active');
      }
    }

    function calculateRefrigerant() {
      const pipeLen = parseFloat(el('refrig-pipe-length')?.value);
      if (isNaN(pipeLen) || pipeLen <= 0) {
        alert(i18n.alerts?.pipe_length || 'Please enter a valid pipe length.');
        return;
      }

      const series = el('refrig-series')?.value;
      const capacity = el('refrig-capacity')?.value;
      const data = REFRIG_DATA[series];
      const maxLen = data.maxLen[capacity];

      if (pipeLen > maxLen) {
        const confirmMsg = t(i18n.alerts?.pipe_length_confirm, { length: pipeLen, max: maxLen });
        if (!confirm(confirmMsg)) return;
      }

      const extraLen = Math.max(0, pipeLen - data.precharge);
      const additionalCharge = extraLen * data.rate;
      const seriesName = series.charAt(0).toUpperCase() + series.slice(1);
      const refrigResult = i18n.refrig?.result || {};
      const container = el('refrig-result-container');

      if (!container) return;

      container.innerHTML = `
        <div class="ms-result-card">
          <div class="ms-tag ms-tag-seer2">${data.refrigerant}</div>
          <div style="margin-top: 24px;">
            <p class="ms-result-title">${refrigResult.title || 'Additional Charge Required'}</p>
            <div class="ms-result-btu">${additionalCharge.toFixed(2)} oz</div>
            <p class="ms-result-coverage">${t(refrigResult.coverage, { length: extraLen.toFixed(1) })}</p>
          </div>
          <div class="ms-result-details">
            <p><strong>${refrigResult.system || 'System:'}</strong> ${seriesName} ${capacity}</p>
            <p><strong>${refrigResult.precharge || 'Pre-charge:'}</strong> ${data.precharge} ft</p>
            <p><strong>${refrigResult.charge_rate || 'Charge Rate:'}</strong> ${data.rate} oz/ft</p>
            <p style="margin-top: 12px; font-size: 13px; font-style: italic;">${refrigResult.disclaimer || '* Ensure the total charge does not exceed system specifications. Always consult a licensed HVAC professional for charging.'}</p>
          </div>
        </div>
      `;
    }

    function resetRefrigerant() {
      if (el('refrig-pipe-length')) el('refrig-pipe-length').value = '';
      if (el('refrig-series')) el('refrig-series').selectedIndex = 0;
      onSeriesChange();
      const container = el('refrig-result-container');
      if (container) {
        container.innerHTML = `<div class="ms-result-placeholder"><p class="ms-placeholder-text">${i18n.placeholders?.refrig || 'Configure your system and click Calculate to see required charge'}</p></div>`;
      }
    }

    const BTU_PER_KW = 3412.14;
    const BTU_PER_TON = 12000;
    const KW_PER_TON = BTU_PER_TON / BTU_PER_KW;
    let currentMode = 'eer';
    let lock = false;

    function setMode(mode) {
      currentMode = mode;
      ['eer', 'seer', 'seer2'].forEach((m) => {
        const field = el(`field-${m}`);
        const btn = el(`btn-${m}`);
        if (field) field.classList.toggle('ms-field-hidden', m !== mode);
        if (btn) btn.classList.toggle('active', m === mode);
      });

      const hints = i18n.hints || {
        eer: 'EER = BTU/h ÷ W at AHRI rated conditions.',
        seer: 'SEER = seasonal energy efficiency ratio.',
        seer2: 'SEER2 ≈ SEER × 0.96 (post-2023 standard).'
      };

      if (el('eff-hint')) el('eff-hint').textContent = hints[mode] || '';
      calcPower();
    }

    function onBTU(val) {
      if (lock) return;
      lock = true;
      const btu = parseFloat(val);
      if (!isNaN(btu) && btu > 0) {
        if (el('inp-kw')) el('inp-kw').value = (btu / BTU_PER_KW).toFixed(3);
        if (el('inp-ton')) el('inp-ton').value = (btu / BTU_PER_TON).toFixed(2);
      } else {
        if (el('inp-kw')) el('inp-kw').value = '';
        if (el('inp-ton')) el('inp-ton').value = '';
      }
      lock = false;
      calcPower();
    }

    function onKW(val) {
      if (lock) return;
      lock = true;
      const kw = parseFloat(val);
      if (!isNaN(kw) && kw > 0) {
        if (el('inp-btu')) el('inp-btu').value = (kw * BTU_PER_KW).toFixed(0);
        if (el('inp-ton')) el('inp-ton').value = (kw / KW_PER_TON).toFixed(2);
      } else {
        if (el('inp-btu')) el('inp-btu').value = '';
        if (el('inp-ton')) el('inp-ton').value = '';
      }
      lock = false;
      calcPower();
    }

    function onTon(val) {
      if (lock) return;
      lock = true;
      const ton = parseFloat(val);
      if (!isNaN(ton) && ton > 0) {
        if (el('inp-btu')) el('inp-btu').value = (ton * BTU_PER_TON).toFixed(0);
        if (el('inp-kw')) el('inp-kw').value = (ton * KW_PER_TON).toFixed(3);
      } else {
        if (el('inp-btu')) el('inp-btu').value = '';
        if (el('inp-kw')) el('inp-kw').value = '';
      }
      lock = false;
      calcPower();
    }

    function updateCross(eer) {
      if (isNaN(eer) || eer <= 0) {
        ['cross-eer', 'cross-seer', 'cross-seer2', 'cross-cop'].forEach((id) => {
          if (el(id)) el(id).textContent = '—';
        });
        return;
      }

      if (el('cross-eer')) el('cross-eer').textContent = eer.toFixed(2);
      if (el('cross-seer')) el('cross-seer').textContent = (eer * 1.1).toFixed(1);
      if (el('cross-seer2')) el('cross-seer2').textContent = (eer * 1.1 * 0.96).toFixed(1);
      if (el('cross-cop')) el('cross-cop').textContent = (eer / 3.412).toFixed(2);
    }

    function clearResults() {
      ['res-btu', 'res-kw', 'res-ton', 'res-w', 'res-amp', 'res-kwh', 'cross-eer', 'cross-seer', 'cross-seer2', 'cross-cop'].forEach((id) => {
        if (el(id)) el(id).textContent = '—';
      });
    }

    function calcPower() {
      const btu = parseFloat(el('inp-btu')?.value);
      if (isNaN(btu) || btu <= 0) {
        clearResults();
        return;
      }

      if (el('res-btu')) el('res-btu').textContent = Math.round(btu).toLocaleString();
      if (el('res-kw')) el('res-kw').textContent = (btu / BTU_PER_KW).toFixed(2);
      if (el('res-ton')) el('res-ton').textContent = (btu / BTU_PER_TON).toFixed(2);

      let eer = NaN;
      if (currentMode === 'eer') {
        eer = parseFloat(el('inp-eer')?.value);
      } else if (currentMode === 'seer') {
        const seer = parseFloat(el('inp-seer')?.value);
        if (!isNaN(seer) && seer > 0) eer = seer / 1.1;
      } else if (currentMode === 'seer2') {
        const seer2 = parseFloat(el('inp-seer2')?.value);
        if (!isNaN(seer2) && seer2 > 0) eer = (seer2 / 0.96) / 1.1;
      }

      if (isNaN(eer) || eer <= 0) {
        if (el('res-w')) el('res-w').textContent = '—';
        if (el('res-amp')) el('res-amp').textContent = '—';
        if (el('res-kwh')) el('res-kwh').textContent = '—';
        updateCross(NaN);
        return;
      }

      const wIn = btu / eer;
      const volt = parseFloat(el('inp-volt')?.value) || 230;
      const amp = wIn / volt;
      const kwh = (wIn / 1000) * 1000;

      if (el('res-w')) el('res-w').textContent = Math.round(wIn).toLocaleString();
      if (el('res-amp')) el('res-amp').textContent = amp.toFixed(2);
      if (el('res-kwh')) el('res-kwh').textContent = Math.round(kwh).toLocaleString();
      updateCross(eer);
    }

    function preset(btu, eerVal) {
      if (el('inp-btu')) el('inp-btu').value = btu;
      if (el('inp-eer')) el('inp-eer').value = eerVal;
      setMode('eer');
      onBTU(String(btu));
    }

    root.querySelectorAll('[data-ms-tab-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => switchTab(btn.dataset.msTabTrigger, btn));
    });

    el('btu-calculate')?.addEventListener('click', calculateBTU);
    el('btu-reset')?.addEventListener('click', resetBTU);
    el('refrig-series')?.addEventListener('change', onSeriesChange);
    el('refrig-capacity')?.addEventListener('change', updateRefrigParams);
    el('refrig-pipe-length')?.addEventListener('input', validatePipeLength);
    el('refrig-calculate')?.addEventListener('click', calculateRefrigerant);
    el('refrig-reset')?.addEventListener('click', resetRefrigerant);

    el('btn-eer')?.addEventListener('click', () => setMode('eer'));
    el('btn-seer')?.addEventListener('click', () => setMode('seer'));
    el('btn-seer2')?.addEventListener('click', () => setMode('seer2'));

    el('inp-btu')?.addEventListener('input', (e) => onBTU(e.target.value));
    el('inp-kw')?.addEventListener('input', (e) => onKW(e.target.value));
    el('inp-ton')?.addEventListener('input', (e) => onTon(e.target.value));
    el('inp-eer')?.addEventListener('input', calcPower);
    el('inp-seer')?.addEventListener('input', calcPower);
    el('inp-seer2')?.addEventListener('input', calcPower);
    el('inp-volt')?.addEventListener('input', calcPower);

    root.querySelectorAll('[data-ms-preset]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const [btu, eerVal] = btn.dataset.msPreset.split(',').map(Number);
        preset(btu, eerVal);
      });
    });

    onSeriesChange();

    const initialTab = root.dataset.initialTab;
    if (initialTab) activateTab(initialTab);
  });
});
